import { TargetedBannerIds } from '../../types';

export enum BannerPlacement {
  MobileTop = 'mobileTop',
  DesktopTop = 'desktopTop',
  Background = 'background',
  Catfish = 'catfish',
  ContentBottom = 'contentBottom'
}

export interface LotriverConfig {
  sid: string;
  bn: string;
  containerId: string;
  containerClassName?: string;
  arCn?: number;
  tagName?: string;
}

export interface AdManagerConfig {
  bannerName: 'catfish' | 'top' | 'deskTop' | 'bottom' | 'bg' | 'search';
  tagName?: string;
}

interface BannerConfigItem {
  lotriver?: LotriverConfig;
  adManager?: AdManagerConfig;

  domId?: TargetedBannerIds;
  reportKey?: string;
}

export interface BannerOverrides {
  lotriver?: Partial<LotriverConfig>;
  adManager?: Partial<AdManagerConfig>;
}

export const BANNER_CONFIG: Record<BannerPlacement, BannerConfigItem> = {
  [BannerPlacement.MobileTop]: {
    lotriver: {
      sid: '220686',
      bn: '2',
      containerId: 'js-lotriver-top-banner',
      containerClassName: 'lotriver-top-banner',
      arCn: 1
    },
    adManager: {
      bannerName: 'top'
    }
  },

  [BannerPlacement.DesktopTop]: {
    lotriver: {
      sid: '220686',
      bn: '1',
      containerId: 'js-lotriver-desk-top-banner',
      containerClassName: 'js-lotriver-desk-top-banner',
      arCn: 1
    },
    adManager: {
      bannerName: 'deskTop'
    }
  },
  [BannerPlacement.Background]: {
    adManager: {
      bannerName: 'bg'
    },
    domId: TargetedBannerIds.bg
  },

  [BannerPlacement.Catfish]: {
    adManager: {
      bannerName: 'catfish'
    },
    domId: TargetedBannerIds.catfish
  },
  [BannerPlacement.ContentBottom]: {
    lotriver: {
      sid: '220686',
      bn: '6',
      containerId: '',
      containerClassName: 'lotriver-bottom-banner content-banner',
      arCn: 0,
      tagName: 'p'
    },
    adManager: {
      bannerName: 'bottom',
      tagName: 'p'
    }
  }
};
